/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} I_Want_ToInputs */

const en_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to…`)
};

const es_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiero…`)
};

const fr_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je veux…`)
};

const de_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich möchte…`)
};

const ja_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私は…をしたい`)
};

const zh_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我想要…`)
};

const ar_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أريد أن...`)
};

const id_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya ingin...`)
};

const it_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voglio…`)
};

const ru_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я хочу…`)
};

const pt_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eu quero…`)
};

const ko_i_want_to = /** @type {(inputs: I_Want_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나는 이것을 원합니다…`)
};

/**
* | output |
* | --- |
* | "I want to…" |
*
* @param {I_Want_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const i_want_to = /** @type {((inputs?: I_Want_ToInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<I_Want_ToInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_i_want_to(inputs)
	if (locale === "es") return es_i_want_to(inputs)
	if (locale === "fr") return fr_i_want_to(inputs)
	if (locale === "de") return de_i_want_to(inputs)
	if (locale === "ja") return ja_i_want_to(inputs)
	if (locale === "zh") return zh_i_want_to(inputs)
	if (locale === "ar") return ar_i_want_to(inputs)
	if (locale === "id") return id_i_want_to(inputs)
	if (locale === "it") return it_i_want_to(inputs)
	if (locale === "ru") return ru_i_want_to(inputs)
	if (locale === "pt") return pt_i_want_to(inputs)
	return ko_i_want_to(inputs)
});